<div class="modal-component">
  <div class="modal-component-body">
    <ng-content></ng-content>
  </div>
</div>
<div class="modal-component-background"></div>
